import { Extension } from '@tiptap/core';
import {
    TestQuestionChoiceNode,
    TestQuestionChoiceNodeHeadless,
    TestQuestionInstructionsNode,
    TestQuestionInstructionsNodeHeadless,
    TestQuestionNode,
    TestQuestionNodeHeadless,
} from './test-question-extension';

export const TestQuestionHeadless = Extension.create({
    name: 'testQuestionWrapper',

    addExtensions() {
        return [TestQuestionNodeHeadless, TestQuestionInstructionsNodeHeadless, TestQuestionChoiceNodeHeadless];
    },
});

export const TestQuestion = TestQuestionHeadless.extend({
    addExtensions() {
        return [TestQuestionNode, TestQuestionInstructionsNode, TestQuestionChoiceNode];
    },
});

export default TestQuestion;
